import {Three as THREE} from "#material/three/exports"
import {z} from "zod/v4-mini"

export const materialType = z.union([z.literal("cycles"), z.literal("three")])
export type MaterialType = z.infer<typeof materialType>

export const materialMaterialSlot = z.optional(z.nullable(z.instanceof(THREE.Material)))
export type MaterialMaterialSlot = THREE.Material | null | undefined
